(function () {
    'use strict';

    angular.module('app.deliveries', ['smart-table', 'treeControl', 'ui.bootstrap', 'ui.grid', 'ui.grid.grouping', 'ui.grid.selection', 'ui.grid.autoResize', 'AngularGM', 'angularFileUpload', 'ngTable', 'ngTagsInput']);
})();